import { Component, OnInit } from '@angular/core';
import { SelfVerificationService } from '../../service/self-verification.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModErrorComponent } from '../../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-my-authorised-accesses',
  templateUrl: './my-authorised-accesses.component.html',
  styleUrls: ['./my-authorised-accesses.component.css']
})
export class MyAuthorisedAccessesComponent implements OnInit {


  accesses : any= [];
  constructor(private dataApi: SelfVerificationService,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog,
              private spinner: NgxSpinnerService,) { }

  ngOnInit() {
    this.spinner.show("loading");
    this.dataApi.getMyAccesses().subscribe(
      (data)=>{
        if(data){
          this.accesses= data.myAccesses;
        }else{
          this.accesses=[]
        }
        this.spinner.hide("loading");
      },
      (err)=>{
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      })
  }

}
